import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { CheckLivraisonsResult, CheckLivraisonsService } from '../../../services/check-livraisons.service';
import { CartoucheLivraisonItem, CartouchesService } from '../../../services/cartouches.service';

@Component({
  selector: 'app-suivi-colis-analyses',
  imports: [CommonModule],
  templateUrl: './suivi-colis-analyses.component.html',
  styleUrl: './suivi-colis-analyses.component.scss'
})
export class SuiviColisAnalysesComponent implements OnInit {
  protected running = false;
  protected result: CheckLivraisonsResult | null = null;
  protected error = '';
  protected lastRunAt: Date | null = null;
  protected loadingCartouchesEnCours = false;
  protected cartouchesEnCours: CartoucheLivraisonItem[] = [];
  protected cartouchesEnCoursError = '';

  constructor(
    private readonly checkLivraisonsService: CheckLivraisonsService,
    private readonly cartouchesService: CartouchesService,
    private readonly cdr: ChangeDetectorRef
  ) {}

  async ngOnInit(): Promise<void> {
    await this.loadCartouchesEnCours();
  }

  protected async runCheck(): Promise<void> {
    if (this.running) {
      return;
    }

    this.running = true;
    this.error = '';
    this.cdr.markForCheck();

    try {
      this.result = await this.checkLivraisonsService.runCheckLivraisons(true);
      await this.loadCartouchesEnCours();
      this.lastRunAt = new Date();
      this.cdr.markForCheck();
    } catch (err: any) {
      this.error = this.extractErrorMessage(err);
      this.cdr.markForCheck();
    } finally {
      this.running = false;
      this.cdr.markForCheck();
    }
  }

  private async loadCartouchesEnCours(): Promise<void> {
    this.loadingCartouchesEnCours = true;
    this.cartouchesEnCoursError = '';
    this.cdr.markForCheck();

    try {
      const items: CartoucheLivraisonItem[] = await firstValueFrom(this.cartouchesService.listLivraisonsFields());
      this.cartouchesEnCours = (items ?? []).filter((item: CartoucheLivraisonItem) => {
        const nom = String(item.statut_livraison_nom ?? '')
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLowerCase();
        return nom === 'en cours de transit';
      });
    } catch (err: any) {
      this.cartouchesEnCours = [];
      this.cartouchesEnCoursError = this.extractErrorMessage(err);
    } finally {
      this.loadingCartouchesEnCours = false;
      this.cdr.markForCheck();
    }
  }

  private extractErrorMessage(err: any): string {
    if (typeof err?.error === 'string' && err.error.trim()) {
      return err.error;
    }
    if (err?.error?.detail) {
      return String(err.error.detail);
    }
    if (err?.error?.message) {
      return String(err.error.message);
    }
    if (err?.message) {
      return String(err.message);
    }
    return 'Erreur inconnue';
  }
}
